import React, {useEffect, useRef} from "react";
import { motion } from "framer-motion";
import Hero from "../Components/Hero";
import ExpertiseCards from "../Components/ExpertiseCards";
import BentoniteMineralsCard from "../Components/BentoniteMineralsCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css";
import "swiper/css/navigation";
import { homeMinerals, homeSlider, whyChooseData } from "../Data";
/*import videoImg from '../Images/home-hero.webp'*/

import csrImg1 from '../Images/gallery-csr-1.webp'
import csrImg2 from '../Images/gallery-csr-2.webp'
import csrImg3 from '../Images/gallery-csr-3.webp'
import csrImg4 from '../Images/gallery-csr-4.webp'
import csrImg5 from '../Images/gallery-csr-5.webp'
import csrImg6 from '../Images/gallery-csr-6.webp'
import csrImg7 from '../Images/gallery-csr-7.webp'
import csrImg8 from '../Images/gallery-csr-8.webp'
import Cta from "../Components/Cta";
import Certificates from "../Components/Certificates";
import ContactSection from "../Components/ContactSection";
import MineralMap from "../Components/MineralMap";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import websiteSchema from "../Schema/WebsiteSchema";
import webPageSchema from "../Schema/WebPageSchema";

const csrImages = [
  {
   img: csrImg1,
   title: "RENEWABLE ENERGY",
  },
  {
   img: csrImg2,
   title: "CSR FOOD DISTRIBUTION TO PHYSICALLY CHALLENGE KIDS",
  },
  {
    img: csrImg3,
    title: "MINE RESTORATION & PLANTATION",
  },
  {
    img: csrImg4,
    title: "CSR BLOOD DONATION CAMP",
  },
  {
    img: csrImg5,
    title: "RAIN WATER HARVESTING",
  },
  {
    img: csrImg6,
    title: "CSR BLOOD DONATION CAMP",
  },
  {
    img: csrImg7,
    title: "CSR EVERYDAY KIT DISTRIBUTION",
  },
  {
    img: csrImg8,
    title: "CSR BLANKET DISTRIBUTION",
  },
];

const Home=()=>{
    useEffect(() => {
    document.title =
      "Bentonite Manufacturer & Industrial Minerals Exporter India";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Iris Impulse India Pvt. Ltd. is a bentonite manufacturer & industrial minerals exporter from India supplying quality minerals for drilling, paper, industrial sectors worldwide."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://irisimpulse.com/");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Bentonite Manufacturer & Industrial Minerals Exporter India"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Iris Impulse India Pvt. Ltd. is a bentonite manufacturer & industrial minerals exporter from India supplying quality minerals for drilling, paper, industrial sectors worldwide."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://irisimpulse.com/");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://irisimpulse.com/Images/home.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Bentonite Manufacturer & Industrial Minerals Exporter India"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Iris Impulse India Pvt. Ltd. is a bentonite manufacturer & industrial minerals exporter from India supplying quality minerals for drilling, paper, industrial sectors worldwide."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://irisimpulse.com/Images/home.webp"
    );
  }
  }, []);

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const fadeLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.9, ease: "easeOut" }
  }
};

const cardAnim = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
};

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const organizationData = organizationSchema();
  const websiteData = websiteSchema();
  const webPageData = webPageSchema({
  url: "https://irisimpulse.com/",
  title: "Bentonite Manufacturer & Industrial Minerals Exporter India",
  description:
    "Iris Impulse India Pvt. Ltd. is a bentonite manufacturer & industrial minerals exporter from India supplying quality minerals for drilling, paper, industrial sectors worldwide.",
  image: "https://irisimpulse.com/Images/home.webp",
});
  
    return(
        <>

        <SchemaMarkup data={organizationData} />
        <SchemaMarkup data={websiteData} />
        <SchemaMarkup data={webPageData} />

        {/**HERO SECTION */}
        <Hero />


        {/**YOUTUBE VIDEO SECTION */}


<section className="video-section container">
  

  <motion.div
    className="video-wrapper"
    variants={fadeLeft}
    initial="hidden"
    whileInView="visible"
   iewport={{ once: true, margin: "-50px" }}
  >
    {/*<iframe src="https://www.youtube.com/embed/hdMu89Qd9H8?rel=0&modestbranding=1" title="Iris Impulse Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>*/}
    {/*<img src={videoImg} alt="Leading Bentonite Manufacturer & Industrial Minerals Exporter from India | Iris Impulse India Pvt. Ltd." />*/}
      <iframe src="https://www.youtube.com/embed/hdMu89Qd9H8?rel=0&modestbranding=1" title="Iris Impulse Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
  </motion.div>


  <motion.div
    className="content-wrapper"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <motion.p className="section-subheading" variants={fadeUp}>
      Built on Trust. Driven by Innovation. Focused on the World.
    </motion.p>

    <motion.h2 className="section-heading" variants={fadeUp}>
      Leading Bentonite Manufacturer & Industrial Minerals Exporter from India
    </motion.h2>

    <motion.p className="section-text" variants={fadeUp}>
      <b className="bold">Iris Impulse India Pvt. Ltd.</b> is the Holding Company that controls the industrial activities of Ashirwad Minechem, which consist of research and processing of bentonites and other clay minerals into high value-added products and solutions, while  <b className="bold">Iris Impulse India Pvt. Ltd.</b> focuses Export activities of Group.
    </motion.p>

    <motion.p className="section-text" variants={fadeUp}>
      At  <b className="bold">Iris Impulse India Pvt. Ltd.</b>, we believe long-lasting business is built on trust and innovation. Headquartered in Gandhidham, Kutch, Gujarat, India, we are a leading global supplier and exporter of high-quality industrial minerals and value-added solutions. With a strong focus on sustainable practices, advanced technology, and customer satisfaction, we deliver excellence that meets international standards.
    </motion.p>

    <motion.p className="section-text" variants={fadeUp}>
      Our commitment to innovation and integrity has made us a trusted partner for businesses across industries and continents. Whether it’s reliable sourcing, quality processing, or timely delivery, <b className="bold">Iris Impulse India Pvt. Ltd.</b> ensures products and services that empower growth worldwide.
    </motion.p>


    <motion.div className="btn-group" variants={fadeUp}>
      <motion.a
      href="/about-us"
        className="black-btn"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.97 }}
      >
        KNOW MORE
      </motion.a>

      <motion.a
      href="/contact-us"
        className="outline-btn"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.97 }}
      >
        SEND AN ENQUIRY
      </motion.a>
    </motion.div>
  </motion.div>
</section>

{/**3 cards section */}
<ExpertiseCards />

{/**BENTONITE CARDS SECTION */}
<BentoniteMineralsCard />

{/**INDUSTRIAL MINERALS SLIDER SECTION */}
<section className="slider-section slider-home container">

  {/* HEADING */}
  <motion.h2
    className="section-heading"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    Industrial Mineral Products for Manufacturing & Industrial Sectors
  </motion.h2>

  <div className="slider-container-wrapper">

    {/* ✅ FIXED ARROWS */}
    <div ref={prevRef} className="custom-arrow prev-arrow">
      <motion.span
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        whileHover={{ scale: 1.1 }}
      >
        &#10094;
      </motion.span>
    </div>

    <div ref={nextRef} className="custom-arrow next-arrow">
      <motion.span
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        whileHover={{ scale: 1.1 }}
      >
        &#10095;
      </motion.span>
    </div>

    <Swiper
      modules={[Navigation, Pagination]}
      slidesPerView={3}
      spaceBetween={50}
      loop={true}
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      pagination={{
    clickable: true,
  }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
      }}
      breakpoints={{
   320: { slidesPerView: 1, spaceBetween: 15 }, 
  576: { slidesPerView: 1, spaceBetween: 20 }, 
  768: { slidesPerView: 1, spaceBetween: 30 },   
  1024: { slidesPerView: 2, spaceBetween: 40 },  
  1400: { slidesPerView: 3, spaceBetween: 50 },
  }}
      className="slider-cards-grid"
    >
      {homeMinerals.map((slide) => (
        <SwiperSlide key={slide.id}>
          
          <motion.div
            className="slide-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            whileHover={{ y: -8 }}
          >

            <div className="image-wrapper">
              <motion.img
                src={slide.img}
                alt={`${slide.title} | Iris Impulse India Pvt. Ltd.`}
                initial={{ scale: 1.05 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              />
            </div>

            <div className="slide-content">
              <h3>{slide.title}</h3>
              <p className="description">{slide.desc}</p>

              <motion.a
              href={`/industrial-minerals/${slide.url}`}
                className="underline-btn"
                whileHover={{ x: 5 }}
                whileTap={{ scale: 0.97 }}
              >
                LEARN MORE
              </motion.a>
            </div>

          </motion.div>

        </SwiperSlide>
      ))}
    </Swiper>
  </div>
</section>

    {/**INDUSTRIES SLIDER SECTION */}

    {/*<section className="compact-slider container">


  <motion.h2
    className="section-heading"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    Industrial Applications of Bentonite & Mineral Products
  </motion.h2>

  <Swiper
    modules={[Autoplay]}
    slidesPerView={4}
    spaceBetween={20}
    loop={true}
    autoplay={{ delay: 2000, disableOnInteraction: false }}
    breakpoints={{
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  }}
  >
    {homeSlider.map((item) => (
      <SwiperSlide key={item.id}>

 
        <motion.div
          className="compact-slide"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          whileHover={{ y: -6 }}
        >

        
          <div className="img-wrapper">
            <motion.img
              src={item.img}
              alt={`${item.title} | Iris Impulse`}
              className="slide-img"
              initial={{ scale: 1.04 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: 1.2, ease: "easeOut" }}
            />
          </div>

   
          <div className="slide-info">
            <span className="slide-number">{item.id}</span>

            <motion.h3
              className="slide-text"
              whileHover={{ x: 4 }}
            >
              {item.title}
            </motion.h3>
          </div>

        </motion.div>

      </SwiperSlide>
    ))}
  </Swiper>
</section>*/}

 <section className="industries-slider">
  <div className="industries-slider-wrapper">

    {/* LEFT TEXT */}
    <motion.div
      className="industries-slider-left container"
      initial="hidden"
      whileInView="visible"
      variants={fadeLeft}
      viewport={{ once: true }}
    >
      <h2 className="section-heading">
        Industrial Applications of Bentonite & Mineral Products
      </h2>
    </motion.div>

    {/* RIGHT SLIDER */}
    <div className="industries-slider-right">
      <Swiper
        modules={[Autoplay]}
        slidesPerView={4}
        spaceBetween={14}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false
        }}
        speed={800}   // 🔥 smoother slide
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 3 }
        }}
      >
        {homeSlider.map((item) => (
          <SwiperSlide key={item.id}>
            
        <motion.div
  className="industries-card"
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{
    once: false,
    amount: 0.5
  }}
  transition={{
    duration: 0.7,
    ease: "easeOut"
  }}
  whileHover={{ scale: 1.05 }}
>
  <div className="industries-image">

    <img
      src={item.img}
      alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
    />

    <div className="industries-overlay">
      <h3>{item.title}</h3>
      <p className="section-text">{item.desc}</p>
    </div>

  </div>

  <div className="industries-info">
    <h3>{item.title}</h3>
    <p className="section-text">{item.desc}</p>
  </div>
</motion.div>

          </SwiperSlide>
        ))}
      </Swiper>
    </div>

  </div>
</section>
 
        {/**WHY CHOOSE US SECTION */}
       <section className="offers-section">
        <div className="container">

  {/* SUBHEADING */}
  <motion.p
    className="section-subheading"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    Why to collaborate with Iris
  </motion.p>

  {/* HEADING */}
  <motion.h2
    className="section-heading"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    Reliable Mineral Solutions for Global Industries
  </motion.h2>

  {/* TEXT */}
  <motion.p
    className="section-text"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    transition={{ delay: 0.2 }}
    viewport={{ once: true }}
  >
    At <b className="bold">Iris Impulse India Pvt. Ltd.</b>, we combine strong mineral resources, advanced processing facilities, and strict quality standards to deliver reliable bentonite and industrial minerals to global industries.
  </motion.p>

  {/* GRID */}
  <motion.div
    className="offers-grid"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    {whyChooseData.map((item) => (

      <motion.div
        className="offer-card"
        key={item.title}
        variants={cardAnim}
      >
        <motion.div
          className="card-inner"
          whileHover={{ y: -8 }}
        >
           <img src={item.icon} alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}></img>
          <h3 className="card-heading">{item.title}</h3>
          <p>{item.desc}</p>
        </motion.div>
      </motion.div>

    ))}
  </motion.div>
</div>
</section>


    {/**CSR SECTION */}
<section className="home-csr-section container">
  <div className="home-csr-wrapper">

    {/* LEFT CONTENT */}
    <motion.div
      className="home-csr-left"
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <motion.h2 className="section-heading" variants={fadeLeft}>
        Responsible Mining & Sustainable Mineral Development
      </motion.h2>

      <motion.p className="section-text" variants={fadeUp}>
        <b className="bold">Iris Impulse India Pvt. Ltd.</b> is dedicated to eco-friendly operations, responsible mining practices, and sustainable resource management. Through renewable initiatives and meaningful social responsibility programs, the company actively supports local community development, environmental conservation, and long-term ecological balance. Our focus is to create a positive impact by promoting ethical practices, reducing environmental footprint, and preserving natural resources for future generations while contributing to sustainable industrial growth.
      </motion.p>

      <motion.div className="home-csr-btn-wrapper" variants={fadeUp}>
        <motion.a
        href="/about-us/csr-sustainability"
          className="underline-btn"
          whileHover={{ x: 5 }}
          whileTap={{ scale: 0.97 }}
        >
          Learn MORE
        </motion.a>
      </motion.div>
    </motion.div>

    {/* RIGHT IMAGE SLIDER */}
    <motion.div
      className="home-csr-right"
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
      >
        {csrImages.map((item, i) => (
       <Swiper
  modules={[Autoplay]}
  slidesPerView={1}
  loop={true}
  autoplay={{
    delay: 5500,
    disableOnInteraction: false,
  }}
>
  {csrImages.map((item, i) => (
    <SwiperSlide key={i}>

      <div className="home-csr-slide">

        <motion.div
          className="home-csr-img-wrapper"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <motion.img
            src={item.img}
            alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
            initial={{ scale: 1.05 }}
            whileInView={{ scale: 1 }}
            transition={{
              duration: 1.2,
              ease: "easeOut",
            }}
          />
        </motion.div>

        <div className="home-csr-caption">
          <p className="section-text">{item.title}</p>
        </div>

      </div>

    </SwiperSlide>
  ))}
</Swiper>
        ))}
      </Swiper>
    </motion.div>

  </div>
</section>

 {/**MAP SECTION*/}
        <MineralMap />

    {/**CTA SECTION */}
    <Cta />

    {/**CERTIFICATES SECTION */}
    <Certificates/>

    {/**CONTACT FORM SECTION */}
    <ContactSection />
        </>
    )
}
export default Home;